import { render, staticRenderFns } from "./FrameImage.vue?vue&type=template&id=48084bf9&scoped=true&"
import script from "./FrameImage.vue?vue&type=script&lang=ts&"
export * from "./FrameImage.vue?vue&type=script&lang=ts&"
import style0 from "./FrameImage.vue?vue&type=style&index=0&id=48084bf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48084bf9",
  null
  
)

export default component.exports